import React from 'react';

import { WarningOutlined as Warning } from '@ant-design/icons';

interface IProps {
  type: string;
  pixels: any;
}

const rootClass = 'mb-5 flex items-center gap-2 rounded bg-[#3498db] p-2.5 text-white [&>div:first-child]:mr-2.5';
const tagsClass = 'rounded-xs bg-[#2980b9] p-0.5 capitalize';

const TagmanagerAlert = (props: IProps) => {
  const { type, pixels } = props;

  if (type === 'tagmanager' && pixels.filter((t: any) => t.type !== 'tagmanager').length > 0) {
    return (
      <div className={rootClass}>
        <div>
          <Warning style={{ fontSize: 24 }} />
        </div>
        <div>
          Você já possuí o{' '}
          <span className={tagsClass}>
            {pixels
              .filter((item: any) => item.type !== 'tagmanager')
              .map((item: any) => item.type)
              .join(', ')}
          </span>
          , ao instalar o<span className={tagsClass}>Google Tag Manager</span> você pode causar duplicidade de pixels.
          Você tem certeza que sabe o que está fazendo?
        </div>
      </div>
    );
  }

  if (type !== 'tagmanager' && pixels.find((t: any) => t.type === 'tagmanager')) {
    return (
      <div className={rootClass}>
        <div>
          <Warning style={{ fontSize: 24 }} />
        </div>
        <div>
          Você já possuí o <span className={tagsClass}>Google Tag Manager</span> instalado, ao instalar o{' '}
          <span className={tagsClass}>{type}</span> você pode causar duplicidade de pixels. Você tem certeza que sabe o
          que está fazendo?
        </div>
      </div>
    );
  }

  return null;
};

export default TagmanagerAlert;
